import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useOfferLink, TYPE_LINK } from 'cityads-v3/hooks/offers'
import { Coupon } from 'cityads-v3/types/coupon'
import { Offer } from 'cityads-v3/types/offers'
import { RootState } from 'cityads-v3/types/reducer';
import { PROPERTY_ITEM_SLICE } from './Offers'
import classes from './OfferCard.scss'

import Regions from 'cityads-v3/components/Format/Regions'
import Skeleton from '@mui/material/Skeleton'
import Typography from '@mui/material/Typography'

type OfferCardSubheaderProps = {
  offerId: Offer['id']
  entity: Offer | Coupon
  isCoupon?: boolean
  linkSource?: string
}

export default function OfferCardSubheader({
  offerId,
  entity,
  isCoupon,
  linkSource
}: OfferCardSubheaderProps) {
  const { t } = useTranslation(['Offers'])
  const offerName = useSelector((state: RootState) => {
    const offerInfo = state.offers[isCoupon ? 'couponOffersById' : 'offersById']?.[offerId]
    return offerInfo?.translated_name ?? offerInfo?.name
  })
  const regions = useSelector((state: RootState) => state.offers[isCoupon ? 'couponsById' : 'offersById'][entity?.id]?.regions ?? [])
  const geoIds = regions.slice(0, PROPERTY_ITEM_SLICE)
  const [link, linkType] = useOfferLink(offerId, linkSource)

  return entity ? (
    <>
      {geoIds.length ?
        (
          <Typography color="textSecondary" variant="body2">
            {t('region')}: <Typography component="span" color="textPrimary" variant="body2"><Regions ids={geoIds} />{regions.length > PROPERTY_ITEM_SLICE ? ('..[' + regions.length + '+]') : ''}</Typography>
          </Typography>
        ) :
        false
      }
      {isCoupon ? null : <Typography color="textSecondary" variant="body2">id: <Typography component="span" color="textPrimary" variant="body2">{entity?.id}</Typography></Typography>}
      {isCoupon ? (
        <Typography color="textSecondary" variant="body2">
          {t('offer')}:{' '}
          {linkType === TYPE_LINK
            ? <Link className={classes.offerLink} to={link}>{offerName}</Link>
            : typeof link === 'string'
              ? < a className={classes.offerLink} href={link}>{offerName}</a>
              : null
          }
        </Typography>
      ) : null}
    </>
  ) :
    <Skeleton animation="wave" variant="text" width={80} height={16} />
}
